import useSilenceAwareRecorder from 'silence-aware-recorder/react';
import { MicrophoneIcon } from '@heroicons/react/20/solid';
import { useEffect, useState } from 'react';
import { FaSpinner } from 'react-icons/fa';
import { useSpeechToTextMutation } from '../../services/chatService';
import { toast } from 'react-toastify';


const SpeechMic = ({transformSpeech, reordingControlBit, divCls}) => {
    
    const [voiceBlob, setVoiceBlob] = useState();
    const micDivcls = divCls ? divCls : 'absolute right-2 top-1 z-[10]';

    const { startRecording, stopRecording, isRecording, deviceId, setDevice } = useSilenceAwareRecorder({
        onDataAvailable: (data) => setVoiceBlob(data),
        // onVolumeChange: (volume) => console.log(volume),
        silenceDuration: 50000,
        silentThreshold: -55,
        minDecibels: -100,
    });


    useEffect(() => {
        return () => {
            if(isRecording){
                stopRecording();
            }
        };
    }, []);

    useEffect(() => {
        if(isRecording){
            stopRecording();
        }
    }, [reordingControlBit]);

    const [speechToText, {isLoading: processingSpeech}] = useSpeechToTextMutation();
    const onRecordingChunkAvailable = (blob) =>{

        const formData = new FormData();
        formData.append('file', blob);

        speechToText(formData).then((res) => {
            if(res?.data?.code === 0){
                if(res.data.data?.text){
                    const finalMsg = res.data.data?.text.trim()
                    transformSpeech(finalMsg)
                }
            }
            else {
                toast.error(res?.data?.msg);
            }
        });
    }

    // call function when voiceBlob available and Recoding stopped.
    useEffect(()=>{
        if(voiceBlob && !isRecording){
            onRecordingChunkAvailable(voiceBlob);
            setVoiceBlob(null)
        }
    }, [isRecording, voiceBlob])


    return(
        <div className={micDivcls}>
            <button
                type='button'
                className={`p-2 rounded-full mb-[0.29rem] relative ${
                    isRecording ? 'bg-green-500 hover:bg-green-600 wave' : ' bg-transparent hover:bg-gray-200 '
                }  focus:outline-none`}
                onClick={isRecording ? stopRecording : startRecording}
            >
                {processingSpeech ? <FaSpinner className="animate-spin" size={16} /> : <MicrophoneIcon className={`h-4 w-4 ${isRecording ? 'text-white': 'text-gray-400'}`} /> }
                {isRecording ? <div className="absolute inset-0 rounded-full border-2 border-white animate-ping" /> : null}
            </button>
        </div>
    )

}

export default SpeechMic;
